export var isActiveStepAfter = function (steps, stepToCompare) {
    var activeStepIndex = steps.findIndex(function (step) { return step.isActive; });
    var stepsTypes = steps.map(function (step) { return step.type; });
    return stepsTypes.indexOf(stepToCompare) < activeStepIndex;
};
